import { Formik, Field, Form, ErrorMessage } from "formik";
import ConfirmationForm from "./confirmation-form";
import "./join-us.css";
import { useThirdViewHook } from "./useThirdViewHook";

// Validation Schema with Yup

const ThirdView = (props) => {
  const {
    showPassword,
    isTermsAccepts,
    formData,
    setTermsAccepted,
    validationSchema,
    togglePasswordVisibility,
    handleNavigate,
    handleSubmit,
  } = useThirdViewHook(props);

  return (
    <div className="container h-100 my-5">
      <ConfirmationForm 
      email={formData.email}
      sponsorName={props.sponsorName}
      setTermsAccepted={setTermsAccepted} />
      <div className="row">
        <div className="col-md-12">
          <legend className="text-center header text-success my-3">
            <h4>GENERAL INFORMATION</h4>
          </legend>

          {/* Formik Form */}
          <Formik
            initialValues={{
              firstName: formData.firstName,
              lastName: formData.lastName,
              password: formData.password,
              email: formData.email,
              phone: formData.phone,
            }}
            validationSchema={validationSchema}
            onSubmit={(values, formikHelper) => {
              handleSubmit(formikHelper);
            }}
          >
            {({ errors, touched, isSubmitting }) => (
              <Form>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="firstName" className="required mb-2">
                        First Name: <span className="required-icon"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text p-spacing">
                            <i className="fa fa-user bigicon"></i>
                          </span>
                        </div>
                        <Field
                          id="firstName"
                          name="firstName"
                          type="text"
                          placeholder="First Name"
                          className={`form-control ${
                            errors.firstName && touched.firstName
                              ? "field-error"
                              : ""
                          }`}
                        />
                      </div>
                      <ErrorMessage
                        name="firstName"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="lastName" className="required mb-2">
                        Last Name: <span className="required-icon"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text p-spacing">
                            <i className="fa fa-user bigicon"></i>
                          </span>
                        </div>
                        <Field
                          id="lastName"
                          name="lastName"
                          type="text"
                          placeholder="Last Name"
                          className={`form-control ${
                            errors.lastName && touched.lastName
                              ? "field-error"
                              : ""
                          }`}
                        />
                      </div>
                      <ErrorMessage
                        name="lastName"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <div className="form-group position-relative">
                      <label htmlFor="password" className="required mb-2">
                        Password: <span className="required-icon"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text p-spacing">
                            <i className="fa fa-lock bigicon"></i>
                          </span>
                        </div>
                        <Field
                          id="password"
                          name="password"
                          type={showPassword ? "text" : "password"}
                          placeholder="Password"
                          className={`form-control ${
                            errors.password && touched.password
                              ? "field-error"
                              : ""
                          }`}
                        />
                      </div>
                      <button
                        type="button"
                        onClick={togglePasswordVisibility}
                        className="btn-eye"
                      >
                        <i
                          className={`fa ${
                            showPassword ? "fa-eye-slash" : "fa-eye"
                          }`}
                        ></i>
                      </button>
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="email" className="required mb-2">
                        Email: <span className="required-icon"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text p-spacing">
                            <i className="fa fa-lock bigicon"></i>
                          </span>
                        </div>
                        <Field
                          id="email"
                          name="email"
                          type="email"
                          placeholder="Email Address"
                          className={`form-control ${
                            errors.email && touched.email ? "field-error" : ""
                          }`}
                        />
                      </div>
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="phone" className="required mb-2">
                        Contact Number:{" "}
                        <span className="required-icon"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text p-spacing">
                            <i className="fa fa-lock bigicon"></i>
                          </span>
                        </div>
                        <Field
                          id="phone"
                          name="phone"
                          type="text"
                          placeholder="Phone/Cell"
                          className={`form-control ${
                            errors.phone && touched.phone ? "field-error" : ""
                          }`}
                        />
                      </div>
                      <ErrorMessage
                        name="phone"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </div>
                </div>
                <div className="row my-4">
                  <div className="col-md-7">
                    <button
                      disabled={!isTermsAccepts || isSubmitting}
                      type="submit"
                      className="btn btn-success py-2 px-4 btn-lg me-3"
                    >
                      {isSubmitting && (
                        <i className="fas fa-spinner fa-spin"></i>
                      )}
                      {!isSubmitting && "Confirm and Proceed"}
                    </button>
                    <button
                      className="btn btn-warning py-2 px-4 btn-lg me-2 mt-1"
                      type="reset"
                    >
                      Reset
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger py-2 px-4 mx-2 btn-lg mt-1"
                      onClick={handleNavigate}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default ThirdView;
